import styles from "./TourShareModal.module.css";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useState } from "react";
import { setAlertMessageSelector } from "../../hooks/store/setters";
import { useAppStore } from "../../hooks/store/useAppStore";

const TourShareModal = ({ show, handleClose, tourId }) => {

    const [width, setWidth] = useState(100);
    const [height, setHeight] = useState(100);
    const url = window.location.origin+"/view-tour/"+tourId+"?welcome=0";
    const setAlertMessage = useAppStore(setAlertMessageSelector);
    const iframeUrl = `
        <iframe src="${url}"
            width=${width}% 
            height=${height}% 
            border="none" 
            allowfullscreen 
        />
    `;
    

    const copyToClipBoard = (text) => {
        navigator.clipboard.writeText(text);
        document.execCommand("copy");
        setAlertMessage("Copied to clipboard");
    }
    
    return (
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <span>Share Tour</span>
            <div className={styles.modalsubTitle}>Share tour link or embed to your website</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className={styles.copyLink}>
                <h6>Copy Link</h6>
                <div className={styles.copyLinkContent}>
                    <span>{ url }</span>
                    <Button variant="light" className={styles.copyBtn} onClick={() => copyToClipBoard(url)}>
                        copy
                    </Button>
                </div>
            </div>
            <div className={styles.copyLink}>
                <h6>Embed Code</h6>
                <div className={styles.copyLinkContent}>
                    <span>
                        { iframeUrl }
                    </span>
                    <Button variant="light" className={styles.copyBtn} onClick={() => copyToClipBoard(iframeUrl)}>
                        copy
                    </Button>
                </div>
                <div className={styles.copySettings}>
                    <div className={styles.copySetting}>
                        <label>Width</label>
                        <input type="number" min="0" max="100" value={width} onChange={(e) => setWidth(e.target.value)}/> %
                    </div>
                    <div className={styles.copySetting}>
                        <label>Height</label>
                        <input type="number" min="0" max="100" value={height} onChange={(e) => setHeight(e.target.value)}/> %
                    </div>
                </div>
            </div>
        </Modal.Body>
      </Modal>
    );
};

export default TourShareModal;